import filter from 'lodash/fp/filter'

//noinspection JSUnusedGlobalSymbols
export default {

    all: state => Object.values(state.entities),

    allByProductId: (state, getters) => productId => {
        return filter(['product', productId])(getters['all'])
    }

}


